import { gql } from 'graphql-request'
import {
  fragmentBlockHeadingQuery,
  fragmentBlockRichTextQuery,
  fragmentBlockMediaArrayQuery,
  fragmentBlockLinksQuery,
  fragmentBlockSummaryQuery,
} from '../fragments/blocks'

export const SingleRoomQuery = gql`
  query SingleRoom(
    $slug: Room_slug_operator,
    $isPreview: Boolean! = false,
    $statuses: [Room__status_Input] = [published],
    $locale: LocaleInputType!
  ) {
    Rooms(
      draft: $isPreview,
      locale: $locale,
      where: {
        AND: [
          { slug: $slug }
          { _status: { in: $statuses } }
        ]
      }
    ) {
      docs {
        id
        title
        slug
        description
        room
        floor
        maskShape {
          id
          filename
          url
          width
          height
        }
        personOccurrences {
          docs {
            id
            title
            dateStart
            dateEnd
            isOngoing
            type
            person {
              id
              title
              slug
            }
          }
        }
        programme {
          docs {
            id
            title
            slug
            recurrences {
              id
              dateTimeStart
              dateTimeEnd
            }
            type {
              ... on ProgrammeType {
                id
                title
                slug
              }
            }
          }
        }
        media {
          docs ${fragmentMediaWithCoverQuery}
        }
      }
      totalDocs
    }
  }
`
